module.exports = __webpack_public_path__ + "static/img/bitmap.e0948d48.png";